import { ElementRef } from "@angular/core";
import { CreativeUnitWithCustomizationsDto } from "../../../../../../../api/src/creative-unit-package/models/creative-unit/creative-unit.dto";


export enum AdStudioContainerTabState {
	CUSTOMIZATIONS = 'customizations',
	CREATIVE_UNIT_LAYERS = 'creativeUnitLayers',
	CREATIVE_UNIT_SETTINGS = 'creativeUnitSettings',
	PACKAGE_SETTINGS = 'packageSettings',
	PACKAGE_LAYERS = 'packageLayers',
	STYLES = 'styles',
	DEBUG = 'debug',
	REVIEW = 'review'
}

export namespace AdStudioContainerTabState {
	export function getAdStudioContainerTabStateIcon(tabState: AdStudioContainerTabState) {
		switch (tabState) {
			case AdStudioContainerTabState.CUSTOMIZATIONS:
				return 'tune';
			case AdStudioContainerTabState.PACKAGE_SETTINGS:
				return 'settings';
			case AdStudioContainerTabState.REVIEW:
				return 'rate_review';
			case AdStudioContainerTabState.CREATIVE_UNIT_SETTINGS:
				return 'settings';
			case AdStudioContainerTabState.PACKAGE_LAYERS:
				return 'layers';
			case AdStudioContainerTabState.CREATIVE_UNIT_LAYERS:
				return 'layers';
			case AdStudioContainerTabState.STYLES:
				return 'format_paint';
			case AdStudioContainerTabState.DEBUG:
				return 'bug_report';
		}
	}
}

export class TimelineEvent {
	id: CreativeUnitWithCustomizationsDto['id'];
	type: TimelineEventType;
	timeline: GSAPTimeline;
}

export enum TimelineEventType {
	INIT = 'init',
	PLAY = 'play',
	PAUSE = 'pause',
	COMPLETE = 'complete'
}
